<bzg-modal-header>
  <span class="bzg-modal__header">{{'CERTIFICATE.PASSWORD' | translate}}</span>
</bzg-modal-header>
<bzg-modal-content>
  <bzg-input name="password" [(ngModel)]="password" type="{{showPassword ? 'text':'password'}}"
    (blur)="encryptPassword()" [maxlength]="maxLengthPassword()" actionIcnPosition="right"
    [placeholder]="'CERTIFICATE.PASSWORD' | translate">
    <bzg-icon nameIcon="icon-eye" *ngIf="showPassword" (click)="showEncrypt()"></bzg-icon>
    <bzg-icon nameIcon="icon-eye-closed" *ngIf="!showPassword" (click)="showEncrypt()"></bzg-icon>
  </bzg-input>
</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="ok()">{{'GLOBAL.SAVE' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
